import { REQUEST_STATUSES } from "@/constants/index.js";

const initialState = {
  element: {},
  status: REQUEST_STATUSES.IDLE,
  err: null,
};

export const currentElementSelector = (state) => ({ ...initialState, ...(state.currentElement || {}) });
